class AtnlSelect {
	constructor(selectClass = '.atnl-select') {
		this.selectClass = selectClass;
		this.getThisSelect = (el) => el.closest && el.closest(this.selectClass)
		this.getThisButton = (el) => this.getThisSelect(el)?.querySelector('[role="combobox"]')
		this.getThisList = (el) => this.getThisSelect(el)?.querySelector('[role="listbox"]')
		this.isRadio = (el) => el.closest('.--radio')
		this.activeSelect = false;
		this.changeEvent = new Event('change', { bubbles: true });
		this.scrollTimeout;
		this.scrollInterval;
		this.scrollListener;
		this.init();
	}
	init() {
		// Navigation listeners
		window.addEventListener('click', (e) => this.expanderBt(e.target), false); // open close
		window.addEventListener('click', (e) => this.closeOnClickOut(e.target), false); // open close
		window.addEventListener('mouseover', (e) => this.focusOption(e.target)) // focus on mouseover
		window.addEventListener('keydown', (e) => e.key === 'ArrowDown' && this.goToNextEl(e), false) // arrow down
		window.addEventListener('keydown', (e) => e.key === 'ArrowUp' && this.goToPrevEl(e), false) // arrow up
		window.addEventListener('keydown', (e) => (e.key === 'Escape' || e.key === 'Tab') && !document.activeElement.closest('[no-toggle]') && this.close(document.activeElement), false) // Selection

		// scroll button listeners
		window.addEventListener('mouseover', (e) => {
			e.target.closest('.btscroll-down.show') && this.scrollButton(e.target, 'down')
			e.target.closest('.btscroll-up.show') && this.scrollButton(e.target, 'up')
		})
		window.addEventListener('mouseover', (e) => {
			if (!e.target.closest('.btscroll-down.show,.btscroll-up.show')) {
				clearInterval(this.scrollInterval);
				clearTimeout(this.scrollTimeout);
			}
		})

		// actions
		window.addEventListener('click', (e) => this.clearBt(e.target), false); // clear
		window.addEventListener('click', (e) => this.selectAllBt(e.target), false); // selectAll
		window.addEventListener('click', (e) => this.optionChecker(e.target), false)// check/uncheck
		// check/uncheck spacebar
		window.addEventListener('keydown', (e) => {
			if (e.code === "Space" || e.key === " " || e.key === 'Enter') {
				e.target.closest('[role="option"]') && e.view.event.preventDefault()
				this.optionChecker(document.activeElement)
			}
		}, false)

	}

	// Navigation
	open(el) {
		const select = this.getThisSelect(el);
		if (!select) return;
		const button = this.getThisButton(el);
		const list = this.getThisList(el);
		button.setAttribute('aria-expanded', "true")
		list.setAttribute('aria-hidden', "false")
		this.activeSelect && this.activeSelect !== select && this.close(this.activeSelect)
		this.activeSelect = select;
		this.scrollListener = this.throttle(() => this.scrollButtonsState(list), 200);
		list.addEventListener('scroll', this.scrollListener, false);
		setTimeout( () => this.scrollButtonsState(list), 1000);
		window.matchMedia("(pointer:fine)").matches && setTimeout(() => {
			el === button && select.querySelector(`[tabindex]:not([tabindex="-1"]):not(.bt-clear)`).focus()
		}, 100);
	}
	close(el) {
		const select = this.getThisSelect(el);
		if (!select) return;
		const button = this.getThisButton(el);
		const list = this.getThisList(el);
		list.removeEventListener('scroll', this.scrollListener, false);
		setTimeout(() => {
			list.setAttribute('aria-hidden', "true")
			button.setAttribute('aria-expanded', "false")
			if (this.activeSelect === select) {
				this.activeSelect = false;
				button.focus()
			}
		}, 10);
	}
	toggle(el) {
		const select = this.getThisSelect(el);
		if (!select) return;
		const button = this.getThisButton(el);
		const state = button.getAttribute('aria-expanded')
		state === "true" ? this.close(el) : this.open(el);
	}
	expanderBt(el) {
		const button = this.getThisButton(el);
		if (!button || button.closest('[no-toggle]')) return;
		(button === el) && this.toggle(el)
	}
	closeOnClickOut(el) {
		const select = this.getThisSelect(el);
		if (!select) {
			document.querySelectorAll(this.selectClass)?.forEach(el => !el.closest('[no-toggle]') && this.close(el))
		}
	}
	getFocusThree(el) {
		return this.getThisSelect(el).querySelectorAll('[tabindex]:not([tabindex="-1"]):not(.bt-clear')
	}
	goToNextEl(e) {
		let select = this.getThisSelect(document.activeElement);
		if (!select) return;
		e.view.event.preventDefault();
		let focusThree = this.getFocusThree(select);
		let goToNext = false;
		if (focusThree) {
			for (let i = 0; i < focusThree.length; i++) {
				if (goToNext) {
					focusThree[i].focus()
					goToNext = false;
					break;
				}
				goToNext = document.activeElement === focusThree[i];
			}
		}
	}
	goToPrevEl(e) {
		let select = this.getThisSelect(document.activeElement);
		if (!select) return;
		e.view.event.preventDefault();
		let focusThree = this.getFocusThree(select);
		let prevEl = false;
		if (focusThree) {
			for (let i = 0; i < focusThree.length; i++) {
				if (document.activeElement === focusThree[i]) {
					if (prevEl) {
						prevEl.focus()
					}
					break;
				};
				prevEl = focusThree[i]
			}
		}
	}
	focusOption(target) {
		if (!window.matchMedia("(pointer:fine)").matches) return;
		let option = target.closest('[role="option"]');
		if (!option) return;
		option.focus()
	}
	trapTabKey() {
		if (document.activeElement.closest(`${this.selectClass} [role="group"]:last-of-type [role="option"]:last-child, ${this.selectClass} [role="listbox"] > [role="option"]:last-of-type`)) {
			setTimeout(() => this.getThisButton(this.activeSelect).focus(), 5);
		}
	}
	scrollButtonsState(list) {
		const scrollTop = list.scrollTop;
		const scrollHeight = list.scrollHeight;
		const clientHeight = list.clientHeight;
		const btScrollUp = list.querySelector('.btscroll-up');
		const btScrollDown = list.querySelector('.btscroll-down');
		btScrollUp && scrollTop > 0
			? btScrollUp.classList.add('show')
			: btScrollUp.classList.remove('show')
		btScrollDown && Math.ceil(scrollTop + clientHeight) < Math.ceil(scrollHeight)
			? btScrollDown.classList.add('show')
			: btScrollDown.classList.remove('show')
	}

	scrollButton(button, direction = 'up') {
		let list = this.getThisList(button);
		if (!list) return;
		clearInterval(this.scrollInterval);
		clearTimeout(this.scrollTimeout);
		this.scrollTimeout = setTimeout(() => {
			this.scrollInterval = setInterval(() => {
				direction === 'up' ? list.scrollTop -= 3 : list.scrollTop += 3
			}, 10);
		}, 250);
	}

	//States
	clear(el, fireChange = true) {
		const select = this.getThisSelect(el);
		if (!select) return;
		let inputs = select.querySelectorAll('input')
		inputs && inputs.forEach(input => this.optionChecker(input, false, fireChange));
	}
	selectAll(el) {
		const select = this.getThisSelect(el);
		if (!select) return;
		let inputs = select.querySelectorAll('input')
		inputs && inputs.forEach(input => this.optionChecker(input, select.dataset.nSel !== 'all'));
	}
	clearBt(el) {
		const button = el.closest('.bt-clear')
		if (!button) return;
		this.close(el)
		setTimeout(() => this.clear(el), 50);
	}
	selectAllBt(el) {
		const button = el.closest('.bt-all')
		if (!button) return
		setTimeout(() => {
			button.getAttribute('aria-checked') === "false" ? this.selectAll(el) : this.clear(el);
		}, 50);
	}
	clearBtState(el, state = true) {
		const button = this.getThisSelect(el)?.querySelector('.bt-clear')
		if (!button) return;
		setTimeout(() => {
			if (state) {
				button.setAttribute('aria-hidden', 'false')
			} else {
				document.activeElement === button && this.getThisButton(el).focus();
				setTimeout(() => {
					button.setAttribute('aria-hidden', 'true')
				}, 10);
			}
		}, 50);
	}
	selectAllBtState(el, state = true) {
		const button = this.getThisSelect(el)?.querySelector('.bt-all');
		if (!button) return;
		button.setAttribute("aria-checked", state ? "true" : "false");
		button.querySelector('input').checked = state;
		if (state) {
			button.setAttribute('aria-label', button.dataset.unselectLabel);
			button.querySelector('span').textContent = button.dataset.unselectLabel
			button.setAttribute('aria-labelledby', "false");
		} else {
			button.removeAttribute('aria-label')
			button.setAttribute('aria-labelledby', button.querySelector('span').getAttribute('id'));
			button.querySelector('span').textContent = button.dataset.selectLabel
		}
	}
	optionChecker(target, forceState = null, fireChange = true) {
		let label = target.closest(`${this.selectClass} [role="option"]`);
		if (!label) return;
		let input = label.querySelector('input')
		let state = forceState ?? !input.checked;
		label.setAttribute('aria-selected', state ? "true" : "false")
		input.checked = state;
		this.doCount(target);
		if( this.isRadio(input) ){
			this.close(input)
			state && this.uncheckAriaSelects(label)
		}
		if (fireChange) {
			const event = new CustomEvent('change', { bubbles: true, detail: { origin: 'atnl_select', select: this.getThisSelect(target) } });
			input.dispatchEvent(event);
		}
		return true
	}
	uncheckAriaSelects(except){
		const select = this.getThisSelect(except);
		if (!select) return;
		let labels = select.querySelectorAll('[role="option"]')
		labels && labels.forEach(label => except !== label && label.setAttribute('aria-selected', 'false'));
	}

	doCount(el) {
		let select = this.getThisSelect(el);
		if (!select) return;
		let button = select.querySelector('[role="combobox"]');
		setTimeout(() => {
			let checkedItems = select.querySelectorAll('[role="option"] input:checked');
			select.dataset.nSel = checkedItems.length
			button.dataset.nSel = checkedItems.length
			if (select.dataset.nSel === select.dataset.n) {
				select.dataset.nSel = 'all';
			}
			if (select.dataset.nSel > 0 || select.dataset.nSel === 'all') {
				this.selectAllBtState(select, true);
			} else {
				this.selectAllBtState(select, false);
			}
			this.clearBtState(select, select.dataset.nSel !== "0");
			this.expanderState(select);
		}, 10);
	}
	expanderState(el) {
		let select = this.getThisSelect(el);
		if (!select) return;
		let button = select.querySelector('[role="combobox"]');
		let checkedItems = select.querySelectorAll('[role="option"] input:checked');
		let originalLabel = document.querySelector(`#${button.dataset.labelId}`).textContent;
		button.setAttribute('aria-labelledby', checkedItems.length ? "false" : button.dataset.labelId);
		button.removeAttribute('aria-label');
		button.querySelector('.selection')?.remove()
		if (!checkedItems.length){
			button.setAttribute('title',this.trimChar(originalLabel, [' ', ',']));
			return;
		}
		let label = checkedItems.length > 1
			? select.dataset.labelSelectedPlural.replace('%s', checkedItems.length)
			: select.dataset.labelSelectedSingular
		let labelSelected = '';
		for (let i = 0; i < checkedItems.length && i <= 4; i++) {
			if (i < 4) labelSelected += checkedItems[i].parentElement.textContent + ", "
			if (i == 4) labelSelected += ' ' + select.dataset.labelMore.replace('%s', checkedItems.length - i)
		}
		button.setAttribute('aria-label', this.trimChar(label + labelSelected, [' ', ',']));
		button.setAttribute('title',this.trimChar(originalLabel + ': ' + labelSelected, [' ', ',']));
		this.isRadio(el) && button.insertAdjacentHTML('beforeend', `<span class="selection" aria-hidden="true">${checkedItems[0].parentElement.textContent}</span>`)
	}

	// helpers
	throttle(func, limit) {
		let lastFunc;
		let lastRan;
		return function () {
			const context = this;
			const args = arguments;
			if (!lastRan) {
				func.apply(context, args)
				lastRan = Date.now();
			} else {
				clearTimeout(lastFunc);
				lastFunc = setTimeout(() => {
					if ((Date.now() - lastRan) >= limit) {
						func.apply(context, args);
						lastRan = Date.now();
					}
				}, limit - (Date.now() - lastRan));
			}
		}
	}
	trimChar(string, charsToRemove=[' ']) {
		while (charsToRemove.includes(string.charAt(0))) {
			string = string.substring(1);
		}
		while (charsToRemove.includes(string.charAt(string.length - 1))) {
			string = string.substring(0, string.length - 1);
		}
		return string;
	}
}

const atnlSelect = new AtnlSelect();
export default atnlSelect;

// CF7 filters - Display Errors for atnl-select
document.addEventListener( 'wpcf7invalid', ( event ) => {
	let errorSpan = document.createElement('span',{'aria-hidden':'true'})
	errorSpan.classList.add('wpcf7-not-valid-tip')
	let errorFields = event.detail?.apiResponse?.invalid_fields
	errorFields && errorFields.forEach( info => {
		let atnlbsSelectField = document.querySelector(`${event.detail.apiResponse.into} [name="${info.field}"], ${event.detail.apiResponse.into} [name="${info.field}[]"]`).closest('.wpcf7-atnlselect');
		if( !atnlbsSelectField ) return;
		let error = errorSpan.cloneNode();
		error.textContent = info.message;
		atnlbsSelectField.insertAdjacentElement('beforeend',error)
		atnlbsSelectField.classList.add('wpcf7-not-valid');
	})
}, false );

document.addEventListener('wpcf7beforesubmit', (event) => {
	let atnlbsSelectsOldErrors = document.querySelectorAll('.wpcf7-atnlselect .wpcf7-not-valid-tip');
	atnlbsSelectsOldErrors && atnlbsSelectsOldErrors.forEach( el => {
		el.closest('.wpcf7-atnlselect').classList.remove('wpcf7-not-valid');
		el.remove();
	})
})
